export type CanvasCollectionId =
  | "animals"
  | "food"
  | "realistic"
  | "figurative"
  | "abstract"
  | "landscape"
  | "music"
  | "memorial";

export type LocalizedCopy = { en: string; he: string };

/** Canvas gallery collections — matches filename groups on disk. */
export const canvasCollectionCopy: Record<CanvasCollectionId, LocalizedCopy> = {
  animals: {
    en: "Animals",
    he: "חיות",
  },
  food: {
    en: "Food & Still Life",
    he: "אוכל וטבע דומם",
  },
  realistic: {
    en: "Realistic",
    he: "ריאליסטי",
  },
  figurative: {
    en: "Figurative",
    he: "פיגורטיבי",
  },
  abstract: {
    en: "Abstract",
    he: "אבסטרקט",
  },
  landscape: {
    en: "Landscape",
    he: "נוף",
  },
  music: {
    en: "Music & Collaborations",
    he: "מוזיקה ושיתופי פעולה",
  },
  memorial: {
    en: "In Memory",
    he: "בזיכרון",
  },
};

export const canvasCollectionFilterIds = [
  "all",
  "animals",
  "food",
  "figurative",
  "realistic",
  "music",
  "memorial",
] as const;

export type CanvasCollectionFilterId = (typeof canvasCollectionFilterIds)[number];
